import moment from 'moment';
import { FC, useState } from 'react';
import { useEventBus } from '../../../../../hooks/use-event-bus';
import { ButtonArea } from '../../../../shared/button-area/button-area';
import { CloseButton, DialogSubTitle, DialogToolbar } from '../../../../shared/dialog/dialog.styles';
import { withApptRequestIvStatusDialogProvider } from '../../hooks/use-appt-request-iv-status-dialog/hoc';
import { useApptRequestIvStatusDialog } from '../../hooks/use-appt-request-iv-status-dialog/hook';
import { IvInfo } from '../../shared/iv-info/iv-info';
import { ApptRequestIvStatusDialog } from '../appt-request-iv-status-dialog';
import { ManuallyVerifiedButton } from '../shared/manually-verified-button';
import { SelfPayButton } from '../shared/self-pay-button';
import { BoldText } from '../styles';

const PayerNotSetupDialog: FC = () => {
  const { publish } = useEventBus();
  const { opened, onClose, isLoading, locationId, ivSummary, appointmentRequest, getCarrierSummary } =
    useApptRequestIvStatusDialog();
  const [carrierSummary] = useState(getCarrierSummary(ivSummary?.idCarrierName));

  const onSetupPayerClick = async () => {
    publish({
      messageType: 'navigate',
      data: {
        pathname: '/insurance/dashboard',
        crossFrame: true
      }
    });

    onClose();
  };

  return (
    <ApptRequestIvStatusDialog
      opened={opened}
      title="Payer Not Setup or Not Supported"
      subtitle={
        <>
          <BoldText>{`${appointmentRequest?.patient?.firstName} ${appointmentRequest?.patient?.lastName}`}</BoldText>
          {ivSummary?.dateReceived && <>&nbsp;- Run {moment.utc(ivSummary?.dateReceived).local().format('MMM D hA')}</>}
        </>
      }
    >
      <DialogSubTitle sx={{ margin: '20px 0 20px 0', display: 'block' }}>
        The following error(s) were encountered during the insurance verification process:
        <ul>
          <li>
            Missing payer setup for insurance identifier: <BoldText>{carrierSummary?.name}</BoldText>
          </li>
        </ul>
        <br />
        To retry verification, please click "Setup Payer" below to complete the setup for this insurance identifier.
        <br />
        <br />
        Alternatively, you may choose "Manually Verified" if you prefer to verify yourself, or "Self Pay" if the patient
        opts not to use insurance.
      </DialogSubTitle>
      <br />
      <ButtonArea title="Fix Now" buttons={[{ title: 'Setup Payer', onClick: onSetupPayerClick }]} />
      <IvInfo />
      <br /> <br />
      <DialogToolbar>
        <ManuallyVerifiedButton onSuccess={async () => onClose()} disabled={isLoading} />
        <SelfPayButton onSuccess={async () => onClose()} disabled={isLoading} />
        <CloseButton onClick={onClose} disabled={isLoading} />
      </DialogToolbar>
    </ApptRequestIvStatusDialog>
  );
};

export default withApptRequestIvStatusDialogProvider(PayerNotSetupDialog);
